import {
  MAXIMUM_DRAFT_VALUE,
  MAXIMUM_WATER_DENSITY_VALUE,
  MINIMUM_DRAFT_VALUE,
  MINIMUM_WATER_DENSITY_VALUE,
} from '../../../../domain/PortCall/constants'

// Checks if a value has at most two decimal places
export const hasMaxTwoDecimals = value => {
  if (value === '' || value === undefined || value === null) {
    return true
  }

  return /^\d+(\.\d{1,2})?$/.test(value)
}

// Checks if a value has at most three decimal places
export const hasMaxThreeDecimals = value => /^\d+(\.\d{1,3})?$/.test(value)

// Validates draft value

export const validateDraftValue = value => {
  // Number only
  if (Number.isNaN(Number(value))) {
    return { errorType: 'numberOnly', isValid: false }
  }

  // Positive and within max limit
  if (Number(value) < MINIMUM_DRAFT_VALUE) {
    return { errorType: 'positiveOnly', isValid: false }
  }

  // Max limit
  if (Number(value) > MAXIMUM_DRAFT_VALUE) {
    return { errorType: 'over20m', isValid: false }
  }

  // Max two decimals
  if (!hasMaxTwoDecimals(value)) {
    return { errorType: 'maxTwoDecimals', isValid: false }
  }

  return { errorType: null, isValid: true }
}

// Validates water density value

export const validateWaterDensityValue = value => {
  // Blank is allowed
  if (value === undefined || value === null || value === '') {
    return { errorType: null, isValid: true }
  }

  const numericValue = Number(value)

  // Number only
  if (Number.isNaN(numericValue)) {
    return { errorType: 'numberOnly', isValid: false }
  }

  // Between min & max (inclusive)
  if (
    numericValue < MINIMUM_WATER_DENSITY_VALUE ||
    numericValue > MAXIMUM_WATER_DENSITY_VALUE
  ) {
    return { errorType: 'waterDensityRange', isValid: false }
  }

  // Max three decimals
  if (!hasMaxThreeDecimals(value)) {
    return { errorType: 'maxThreeDecimals', isValid: false }
  }

  return { errorType: null, isValid: true }
}
